import { render } from "./CatAlmacenForm.vue?vue&type=template&id=6bc07549&scoped=true"
import script from "./CatAlmacenForm.vue?vue&type=script&lang=js"
export * from "./CatAlmacenForm.vue?vue&type=script&lang=js"

import "./CatAlmacenForm.vue?vue&type=style&index=0&id=6bc07549&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc07549"]])

export default __exports__